import styled from "@emotion/styled";
import { Skeleton } from "@chakra-ui/react";
import useIntersectionObserver from "../hooks/useIntersectionObserver";
import React, { useRef, useState } from "react";
import { VStack, colors } from "goi_common";

export function LazyLoadYoutube({
  src = "https://www.youtube.com/embed/PPhQUcQYFKU",
  lazyLoadRefMarginBottom,
  headText,
  autoplay = false,
  showSkeleton = false,
}: {
  src?: string;
  headText?: string;
  lazyLoadRefMarginBottom?: string;
  /** true면 allow에 autoplay 권한 추가. 기본 false — 기존 호출부 동작 보존 */
  autoplay?: boolean;
  /** true면 로드 전 자리(16:9)를 스켈레톤으로 즉시 예약. 기본 false — 기존 호출부(스크롤형 페이지)는 intersect 전까지 공간 자체를 안 차지하던 동작 보존 */
  showSkeleton?: boolean;
}) {
  const [visible, setVisible] = useState(false);
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const lazyLoadYoutubeRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    root: null,
    target: lazyLoadYoutubeRef,
    onIntersect: () => {
      setVisible(true);
    },
  });

  const isReady = visible && iframeLoaded;

  return (
    <>
      <YoutubeRefWrapper
        ref={lazyLoadYoutubeRef}
        lazyLoadRefMarginBottom={lazyLoadRefMarginBottom}
      ></YoutubeRefWrapper>
      <VStack gap={24} width="100%">
        {headText && (
          <div className="new-head white" style={{ paddingLeft: "8px" }}>
            {headText}
          </div>
        )}

        {(showSkeleton || visible) && (
          <IframeWrapper>
            {showSkeleton && !isReady && (
              <Skeleton
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                startColor={colors.gray100}
                endColor={colors.gray200}
              />
            )}
            {visible && (
              <YoutubeIframe
                src={src}
                title="YouTube video player"
                onLoad={() => setIframeLoaded(true)}
                allow={`accelerometer;${
                  autoplay ? " autoplay;" : ""
                } clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen;`}
              />
            )}
          </IframeWrapper>
        )}
      </VStack>
    </>
  );
}

const IframeWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 56.25%;
`;
const YoutubeIframe = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
`;
const YoutubeRefWrapper = styled.div<{ lazyLoadRefMarginBottom?: string }>`
  position: absolute;
  background-color: transparent;
  width: 100%;
  height: 100px;

  left: 0;
  transform: translateY(
    ${({ lazyLoadRefMarginBottom }) =>
      lazyLoadRefMarginBottom ? lazyLoadRefMarginBottom : "-300px"}
  );
`;
